import { createSignal, onCleanup, onMount } from "solid-js";

export function usePrefersReducedMotion(): () => boolean {
  const [prefersReduced, setPrefersReduced] = createSignal<boolean>(false);

  onMount(() => {
    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    setPrefersReduced(mql.matches);

    const handler = (e: MediaQueryListEvent) => setPrefersReduced(e.matches);
    mql.addEventListener("change", handler);
    onCleanup(() => mql.removeEventListener("change", handler));
  });

  return prefersReduced;
}
